import { useDisplaySettings } from '@src/providers/AppConfigProvider';
import { useCurrency } from '@talos/kyoko';

export const useHomeCurrency = () => {
  const { homeCurrency } = useDisplaySettings();
  return useCurrency(homeCurrency);
};
